/**
 *
 * @param {string} email
 * @returns {boolean}
 */
export function validateEmail(email) {
  const regex = /^[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/
  if (regex.test(email)) {
    return true
  }
  return false
}
